import { initReactI18next } from "react-i18next";

import i18n from "i18next";

import { getEnvironment, LANGUAGES } from "../shared";
import de from "./locales/de.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import id from "./locales/id.json";
import it from "./locales/it.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import lt from "./locales/lt.json";
import pl from "./locales/pl.json";
import ptNew from "./locales/pt-new.json";
import pt from "./locales/pt.json";
import ru from "./locales/ru.json";
import uk from "./locales/uk.json";
import zhCN from "./locales/zh-cn.json";
import zhTW from "./locales/zh-tw.json";

const { isProductionEnv } = getEnvironment();

export const resources = {
    [LANGUAGES.English]: { translation: en },
    [LANGUAGES.Lithuanian]: { translation: lt },
    [LANGUAGES.Russian]: { translation: ru },
    [LANGUAGES.Spanish]: { translation: es },
    [LANGUAGES.Portuguese]: { translation: isProductionEnv ? pt : ptNew },
    [LANGUAGES.French]: { translation: fr },
    [LANGUAGES.Ukrainian]: { translation: uk },
    [LANGUAGES.Japanese]: { translation: ja },
    [LANGUAGES.Korean]: { translation: ko },
    [LANGUAGES.German]: { translation: de },
    [LANGUAGES.Italian]: { translation: it },
    [LANGUAGES.Polish]: { translation: pl },
    [LANGUAGES.ChineseSimplified]: { translation: zhCN },
    [LANGUAGES.ChineseTraditional]: { translation: zhTW },
    [LANGUAGES.Indonesian]: { translation: id }
} as const;

i18n.use(initReactI18next).init({
    lng: LANGUAGES.English,
    fallbackLng: LANGUAGES.English,
    resources,
    keySeparator: "##",
    nsSeparator: false,
    interpolation: {
        escapeValue: false
    },
    returnEmptyString: false,
    react: {
        useSuspense: true
    }
});
